import React, { useState, useEffect } from 'react';
import { Button, Typography } from '@material-ui/core';
import AnimateHeight from 'react-animate-height';
import { ExpandLess, ExpandMore } from '@material-ui/icons';

import { ClientReviewType } from './constants';
import NumberElement from '../../utility/NumberElement';
import { FiveStars } from '../../utility/Icons';
import { isMobile } from '../../../lib/getDeviceSize';
import styles from '../../../pages/reviews/styles';

const WEB_MINIMUM_TEXT_LIMIT = 280;
const MOBILE_MINIMUM_TEXT_LIMIT = 260;
interface Props {
  hideBorderBottom?: boolean;
  review: ClientReviewType;
}
interface State {
  expanded: boolean;
  height: number | string;
}

function ClientReview(props: Props) {
  const classes = styles(props);
  const { review } = props;
  const [state, setState] = useState<State>({
    expanded: false,
    height: 115,
  });
  const [hideExpandToggleState, hideExpandToggle] = useState(false);
  useEffect(() => {
    if (
      props.review.comment.length <
      (isMobile() ? MOBILE_MINIMUM_TEXT_LIMIT : WEB_MINIMUM_TEXT_LIMIT)
    ) {
      hideExpandToggle(true);
    }
  }, []);

  const onExpandToggle = (expanded: boolean) => {
    if (expanded) {
      setState({ expanded: false, height: 115 });
    } else {
      setState({ expanded: true, height: 'auto' });
    }
  };

  const renderComment = (comment: string) => {
    return (
      <div>
        <AnimateHeight
          height={state.height}
          className={
            !hideExpandToggleState
              ? classes.animateHeightContainer
              : classes.animateHeightContainerShort
          }
        >
          <div className={classes.comment}>
            <p
              className={classes.reviewText}
              style={
                state.expanded
                  ? { WebkitLineClamp: undefined }
                  : { WebkitLineClamp: isMobile() ? 5 : 3 }
              }
            >
              {comment}
            </p>
            {!hideExpandToggleState && (
              <Button
                className={classes.expandButtonStyle}
                onClick={(e: any) => {
                  e.stopPropagation();
                  onExpandToggle(state.expanded);
                }}
              >
                {state.expanded ? <ExpandLess /> : <ExpandMore />}{' '}
                <span className={classes.expandButtonText}>
                  Read {state.expanded ? 'Less' : 'More'}
                </span>
              </Button>
            )}
          </div>
        </AnimateHeight>
      </div>
    );
  };

  const renderUserInfo = (reviewDetails: ClientReviewType) => {
    return (
      <div>
        <div className="row">
          <img
            className={classes.image}
            data-alt="review-avatar"
            src={reviewDetails.image}
          />
          <div className={classes.userDetailsContainer}>
            <Typography className={classes.userName}>
              {reviewDetails.name}
            </Typography>
            <Typography className={classes.cityName}>
              {review.location}
            </Typography>
          </div>
        </div>
        <Typography className={classes.savings}>
          Saved <NumberElement val={reviewDetails.savings} prefix="$" />
        </Typography>
      </div>
    );
  };
  const renderReviewRatings = (reviewDetails: ClientReviewType) => {
    return (
      <div className={classes.ratingsContainer}>
        <div className={classes.starBox}>
          <FiveStars small />
        </div>
        <Typography className={classes.commentTitle}>
          {reviewDetails.title}
        </Typography>
        {renderComment(reviewDetails.comment)}
      </div>
    );
  };
  return (
    <React.Fragment>
      <div className={classes.reviewContainer}>
        {renderUserInfo(review)}
        {renderReviewRatings(review)}
      </div>
      {!props.hideBorderBottom && <div className={classes.borderBottom} />}
    </React.Fragment>
  );
}

export default ClientReview;
